export default {
  GET_TYPHOON_ACTIVITY: 'GET_TYPHOON_ACTIVITY',
  GET_TYPHOON_INFO: 'GET_TYPHOON_INFO',
  GET_WEATHER_RADAR: 'GET_WEATHER_RADAR',
  GET_CLOUD_PIC: 'GET_CLOUD_PIC'
}
